import { type CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActiveName = (state: CoreState): string | undefined => {
  return findActiveBrand(state)?.name
}
